import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import SearchBar from "../SearchBar/SearchBar";
import "./Hero.css";

// You can replace these with your own images later
const SLIDES = [
  {
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&q=80",
    eyebrow: "No.1 Real Estate Consultant",
    title: (
      <>
        Find your <em>dream home</em> in India's finest towers.
      </>
    ),
   sub: "Handpicked properties across Punjab and Chandigarh — carefully curated to help you find the right home or investment opportunity.",
    ctaLabel: "Explore Residences",
    ctaTo: "/projects/residential",
  },
  {
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80",
    eyebrow: "Signature Villas · Ready to Move",
    title: (
      <>
        Live the <em>signature life</em>, by the water.
      </>
    ),
    sub: "Sea-facing villas, private pools and skyline penthouses from India's most awarded developers.",
    ctaLabel: "View Luxury Homes",
    ctaTo: "/city/mumbai",
  },
  {
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80",
    eyebrow: "Commercial · Investment Grade",
    title: (
      <>
        Grow wealth with <em>investment</em> properties.
      </>
    ),
    sub: "Grade-A offices, retail plazas and RERA-approved plots hand-picked by our advisory team.",
    ctaLabel: "See Commercial Projects",
    ctaTo: "/projects/commercial",
  },
];

export default function Hero() {
  const [i, setI] = useState(0);
  const count = SLIDES.length;

  const go = useCallback((n) => setI((c) => (n + count) % count), [count]);
  const next = useCallback(() => go(i + 1), [go, i]);
  const prev = useCallback(() => go(i - 1), [go, i]);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next]);

  const current = SLIDES[i];

  return (
    <section className="hero-slider">
      {/* Background slides */}
      {SLIDES.map((s, idx) => (
        <div
          key={idx}
          className={`hero-slide ${idx === i ? "is-active" : ""}`}
        >
          <img
            src={s.image}
            alt="Premium real estate"
            width={1920}
            height={1080}
            loading={idx === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}

      {/* Arrows */}
      <button
        className="hero-arrow prev"
        onClick={prev}
        aria-label="Previous slide"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>
      <button
        className="hero-arrow next"
        onClick={next}
        aria-label="Next slide"
      >
        <ChevronRight className="h-5 w-5" />
      </button>

      {/* Content */}
      <div className="hero-content">
        <div className="hero-container">
          <span key={`e-${i}`} className="hero-eyebrow animate-fade-in">
            <span className="dot" /> {current.eyebrow}
          </span>

          <h1 key={`t-${i}`} className="hero-title animate-fade-in">
            {current.title}
          </h1>

          <p key={`s-${i}`} className="hero-sub animate-fade-in">
            {current.sub}
          </p>

          <div className="hero-cta">
            <Link to={current.ctaTo} className="btn-primary-hero">
              {current.ctaLabel} <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/contact" className="btn-ghost-hero">
              Talk to an Advisor
            </Link>
          </div>

          <div className="hero-search">
            <SearchBar />
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="hero-dots">
        {SLIDES.map((_, idx) => (
          <button
            key={idx}
            className={`hero-dot ${idx === i ? "is-active" : ""}`}
            onClick={() => go(idx)}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
}